


























import { Component, Vue, Prop } from 'vue-property-decorator';
import * as util from "comunet-jobs-and-technician-repository-shared/util";
import { Job } from '@/models/jobSummary/job';
import { JobAssignmentDatesViewModel } from '@/models/jobSummary/jobAssignmentDatesViewModel';
import { JobUserStatusEnum } from '@/types/jobUserStatus';
import moment from 'moment';

@Component({})
export default class JobSummary extends Vue {
  @Prop({ type: Object }) public job!: Job;
  @Prop({ type: Array, default: (): JobAssignmentDatesViewModel[] => [] }) public jobAssignmentDates!: JobAssignmentDatesViewModel[];

  cardPressed() {
    this.$router.push({ name: 'viewjob', params: { jobID: this.job.id } });
  }

  readableDate(dateString: string): string {
    return util.readableDate(dateString);
  }

  get jobStartTime(){
    if(this.job.startTime == null){
      return null;
    }

    return moment(this.job.startTime, "HH:mm:ss").format("HH:mm");
  }

  get clientLocationFriendly() {
    let location = this.job.client.location.siteName;

    if (this.job.client.location.name) {
      location += ` (${this.job.client.location.name})`;
    }

    return location;
  }

  get numberOfTests(){
    return this.job.tests.passed + this.job.tests.failed;
  }

  get jobPhoneHref(): string {
    if(this.job.client.location.contactNumber == null){
      return null;
    }

    return `tel:${this.job.client.location.contactNumber}`;
  }

  get jobColor(){
    if(this.job.assignment.latestStatus.status.id == null){
      return "error";
    }

    if(this.job.assignment.latestStatus.status.id === JobUserStatusEnum.FINISH_WORK){
      return "success";
    }

    return "warning";
  }
}

